<template>
  <v-container fluid>
    <v-toolbar-title style="padding:20px;">Пользователи</v-toolbar-title>

    <mcv-validation-errors
        v-if="validationErrors"
        :validationErrors="validationErrors"
    ></mcv-validation-errors>
    <v-card v-if="user">
      <v-data-table
          :headers="headers"
          :items="user.user"
          item-key="id"
          class="elevation-1">
        <template v-slot:body.prepend>
          <tr class="custom-filter-row">
            <td>
              <v-text-field
                  v-model="id"
                  type="number"
                  label="Номер"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                  v-model="phone"
                  label="Телефон"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                  v-model="first_name"
                  label="Имя"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                  v-model="last_name"
                  label="Фамилия"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                  v-model="middle_name"
                  label="Отчество"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                  v-model="email"
                  label="Email"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                  v-model="created"
                  label="Дата создания"
              ></v-text-field>
            </td>
            <td>
              <v-select
                  v-model="status_id"
                  item-value="value"
                  item-text="name"
                  :items="statusList"
                  label="Выбор статуса"
              ></v-select>
            </td>
          </tr>
        </template>
        <template v-slot:item.status_id="{item}">
          <span>{{ statusListItems[Number(item.status_id)] }}</span>
        </template>
        <template v-slot:item.actions="{item}">
          <v-menu
              bottom
              left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  primary
                  icon
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                  :to="{
                name: 'UsersUpdate',
                params: {slug: item.id}
              }"
              >
                <v-list-item-title>Редактировать</v-list-item-title>

              </v-list-item>



            </v-list>
          </v-menu>
        </template>
      </v-data-table>

    </v-card>


  </v-container>


</template>

<script>
import {mapState} from "vuex";
import {actionTypes} from '@/store/modules/user'
import McvValidationErrors from '@/components/ValidationErrors.vue'

import Vue from 'vue'
import VueExcelEditor from 'vue-excel-editor'

Vue.use(VueExcelEditor)

export default {
  name: 'McvUser',
  components: {
    McvValidationErrors
  },
  data() {
    return {
      jsondata: [
        {user: 'hc', name: 'Harry Cole',    phone: '1-415-2345678', gender: 'M', age: 25, birth: '1997-07-01',user1: 'hc', name1: 'Harry Cole',    phone1: '1-415-2345678', gender1: 'M', age1: 25, birth1: '1997-07-01'},
        {user: 'sm', name: 'Simon Minolta', phone: '1-123-7675682', gender: 'M', age: 20, birth: '1999-11-12'},
        {user: 'ra', name: 'Raymond Atom',  phone: '1-456-9981212', gender: 'M', age: 19, birth: '2000-06-11'},
        {user: 'ag', name: 'Mary George',   phone: '1-556-1245684', gender: 'F', age: 22, birth: '2002-08-01'},
        {user: 'kl', name: 'Kenny Linus',   phone: '1-891-2345685', gender: 'M', age: 29, birth: '1990-09-01'}
      ],
      statusListItems: ["Не активен", "Активен", "Все"],
      id:'',
      phone:'',
      first_name:'',
      last_name:'',
      middle_name:'',
      email:'',
      created:'',
      status_id:''

    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.user.isLoading,
      user: state => state.user.data,
      validationErrors: state => state.user.validationErrors,
    }),
    headers() {
      return [
        {
          text: '#',
          align: 'start',
          sortable: true,
          value: 'id',
          filter: (f) => {
            return (f + "")
                .toLowerCase()
                .includes(this["id"].toLowerCase());
          },
        },
        {
          text: 'Телефон',
          align: 'start',
          sortable: false,
          value: 'phone',
          filter: (f) => {
            return (f + "")
                .toLowerCase()
                .includes(this["phone"].toLowerCase());
          },

        },
        {
          text: 'Имя',
          align: 'start',
          sortable: false,
          value: 'first_name',
          filter: (f) => {
            return (f + "")
                .toLowerCase()
                .includes(this["first_name"].toLowerCase());
          },

        },
        {
          text: 'Фамилия',
          align: 'start',
          sortable: false,
          value: 'last_name',
          filter: (f) => {
            return (f + "")
                .toLowerCase()
                .includes(this["last_name"].toLowerCase());
          },

        },
        {
          text: 'Отчество',
          align: 'start',
          sortable: false,
          value: 'middle_name',
          filter: (f) => {
            return (f + "")
                .toLowerCase()
                .includes(this["middle_name"].toLowerCase());
          },

        },
        {
          text: 'Email',
          align: 'start',
          sortable: false,
          value: 'email',
          filter: (f) => {
            return (f + "")
                .toLowerCase()
                .includes(this["email"].toLowerCase());
          },

        },
        {
          text: 'Дата создания',
          align: 'start',
          sortable: false,
          value: 'created',
          filter: (f) => {
            return (f + "")
                .toLowerCase()
                .includes(this["created"].toLowerCase());
          },

        },
        {
          text: 'Статус',
          align: 'start',
          sortable: true,
          value: 'status_id',
          filter: (f) => {
            return (f + "")
                .includes(this["status_id"]);
          },
        },
        {text: '', value: 'actions', sortable: false},
      ];
    },
    statusList() {
      let statusSet = new Set();
      statusSet.add({ name: "Не активен", value: "false" });
      statusSet.add({ name: "Активен", value: "true" });
      statusSet.add({ name: "Все", value: "" });
      console.log(statusSet)
      return [...statusSet];
    },
  },
  watch: {
  },
  mounted() {
    this.fetchFeed()
  },
  methods: {
    fetchFeed() {
      this.$store.dispatch(actionTypes.getUserList)
    },
  },
}
</script>